import { Close } from '@mui/icons-material';
import { Drawer, IconButton, Typography, Divider, type SxProps, Grid, Box } from '@mui/material';
import React from 'react';

import DrawerNotes from '@/components/Notes/DrawerNotes';
import DrawerTasks from '@/components/Tasks/DrawerTasks';

interface RightDrawerProps {
  open: boolean;
  onClose: () => void;
  sx?: SxProps;
  drawerContentType: string;
}

const RightDrawer: React.FC<RightDrawerProps> = ({ open, onClose, sx = {}, drawerContentType }) => {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      variant="persistent"
      sx={{ textAlign: 'initial', ...sx }}
      slotProps={{
        paper: {
          sx: {
            display: 'flex',
            flexDirection: 'column',
          },
        },
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid container direction="column" sx={{ py: 1.5, px: 2 }} size="grow">
            <Typography variant="h5"> {drawerContentType} </Typography>
            <Typography variant="caption">
              {' '}
              Collection of all {drawerContentType.toLowerCase()} for your account{' '}
            </Typography>
          </Grid>
          <Grid sx={{ textAlign: 'right' }} size={2}>
            <IconButton aria-label="close" onClick={onClose} sx={{ mr: 2, color: (theme) => theme.palette.grey[500] }}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </Box>

      <Divider />

      <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
        {drawerContentType === 'Notes' ? <DrawerNotes /> : <DrawerTasks />}
      </Box>
    </Drawer>
  );
};

export default RightDrawer;
